import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.avaliacoes.length > 1
        ? _c(
            VRow,
            { attrs: { "no-gutters": "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("app-title", { attrs: { texto: "FILTROS" } }),
                  _c("avaliacao-filter", {
                    attrs: { value: _vm.filtros, perspectiva: _vm.perspectiva },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        { staticClass: "mt-4", attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", { attrs: { texto: "ITENS AVALIADOS" } }),
              _c(VDataTable, {
                attrs: { headers: _vm.headers, items: _vm.itensView },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.rating`,
                      fn: function ({ item }) {
                        return [
                          _c("app-rating", {
                            attrs: { value: item.nota, disabled: _vm.disabled },
                            on: {
                              return: function ($event) {
                                item.naoAplica = false
                                _vm.editar(item)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.switch`,
                      fn: function ({ item }) {
                        return [
                          _c(VSwitch, {
                            staticClass: "ma-2",
                            attrs: {
                              disabled: item.naoAplica || _vm.disabled,
                              label: "Não se aplica",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                item.nota.rating = 0
                                _vm.editar(item)
                              },
                            },
                            model: {
                              value: item.naoAplica,
                              callback: function ($$v) {
                                _vm.$set(item, "naoAplica", $$v)
                              },
                              expression: "item.naoAplica",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }